import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useConfig } from '../../context/ConfigContext';
import { asPiccoloError } from '../../utils/errors';

export type HealthQueryResponse = {
  buildInfo: { commit: string; branch: string };
  details: { database: { status: string } };
  status: 'ok' | 'error';
};

export const useHealthQuery = (
  options: Omit<UseQueryOptions<HealthQueryResponse, unknown>, 'queryKey'> = {},
) => {
  const { config } = useConfig();

  return useQuery<HealthQueryResponse, unknown>(
    ['health'],
    async () => {
      try {
        const response = await axios.request({
          url: `${config.api.webUrl}/health`,
          method: 'GET',
        });
        return response.data;
      } catch (err) {
        throw asPiccoloError(err);
      }
    },
    options,
  );
};
